// extracted by mini-css-extract-plugin
module.exports = {"Container":"CreateAccount_Container__1NnqJ","ErrorText":"CreateAccount_ErrorText__x8lX1"};